export const API = process.env.NODE_ENV === 'development'  ? 'http://android-api.jinyijia1688.com': 'https://android-api.jinyijia1688.com' ; //'http://android.jinyijia.com' ////'/api'// 'http://android-api.jinyijia.com'; //'/api' ;//'http://android-api.jinyijia1688.com'; //'http://127.0.0.1:8086' //'http://android.jinyijia.com';// //'http://android.jinyijia.com'; // api
// export const API = 'http://127.0.0.1:8086' // 'https://android-api.jinyijia1688.com'
//
export const OAUTH2 =  API;
// export const API =  'http://android.jinyijia.com'

// export const OAUTH2 =  '';
// export const OAUTH2 =  API; //;//API; //'http://passport.jinyijia.com'; //
